import sendLocalRequest from "./sendLocalRequest";

export const getAlertNotifications = (auth_token) => {
    return  new Promise( (resolve, reject) => {
        sendLocalRequest(`events/alert_notifications`, "GET", auth_token).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
